import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let _cache = null;
let _cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 min client-side

/**
 * Shared hook for library statistics. Consumes GET /api/library/stats.
 * Every public-facing library number MUST use this hook.
 */
export function useLibraryStats() {
  const [stats, setStats] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache && Date.now() - _cacheTime < CACHE_TTL) {
      setStats(_cache);
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/library/stats`);
        if (!cancelled) {
          _cache = data;
          _cacheTime = Date.now();
          setStats(data);
        }
      } catch { /* silent */ }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return { stats, loading };
}
